import { render, staticRenderFns } from "./congrats.vue?vue&type=template&id=0ea07e00&scoped=true&"
import script from "./congrats.vue?vue&type=script&lang=js&"
export * from "./congrats.vue?vue&type=script&lang=js&"
import style0 from "./congrats.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./congrats.vue?vue&type=style&index=1&id=0ea07e00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea07e00",
  null
  
)

export default component.exports